import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SegurancaService } from '@sigepe/ngx-sigepe-seguranca';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import DestroyMixin from 'src/app/components/shared/destroy-mixin';
import { clearValue, CONTROL_CONTAINER_PROVIDER } from '../../control-utils';
import { Item } from '../../models/item';
//import { EstruturaComponent, setReadonlyValue, toItem } from '../../estrutura-component-utils';
import { ConsultaSiapeService, Upag } from '../../../../services/consulta-siape.service';
import { EstruturaComponent, setReadonlyValue, toItem } from '../../estrutura-component-utils';

@Component({
    selector: 'frq-select-upag',
    templateUrl: './select-upag.component.html',
    styleUrls: ['./select-upag.component.scss'],
    viewProviders: [CONTROL_CONTAINER_PROVIDER]
})
export class SelectUpagComponent extends DestroyMixin(Object) implements EstruturaComponent, AfterViewInit {
    @Input() formControlName = 'codigoUpag';
    @Input() required = false;
    @Input() readonly = false;
    @Output() changeCallback? = new EventEmitter<any>();
    @Output() opcoesCarregadas = new EventEmitter<{
        quantidade: number;
        bloqueado: boolean;
    }>();

    private readonly idOrgao$ = new BehaviorSubject<number>(null);
    @ViewChild(NgControl, { static: true }) select!: NgControl;

    originalReadonlyValue;
    upagsItens;

    constructor(
        private estruturaService: ConsultaSiapeService,
        public element: ElementRef<HTMLElement>,
        private segurancaService: SegurancaService
    ) {
        super();
        this.originalReadonlyValue = this.readonly;
    }

    onChangeCallback() {
        //console.debug("onChangeCallback >> " + this.changeCallback);
        this.changeCallback.emit();
    }

    @Input()
    set idOrgao(idOrgao: number) {
        this.idOrgao$.next(idOrgao);
    }

    private loadUpags(idOrgao: number): Observable<Item[]> {
        if (!idOrgao) {
            clearValue(this.select.control);
            return of([]);
        }
        return this.estruturaService.listUpags(idOrgao).pipe(toItem(this));
    }

    ngAfterViewInit(): void {
        //Se tiver apenas 1 item, bloqueia o campo
        this.idOrgao$
            .pipe(
                distinctUntilChanged(),
                switchMap(idOrgao => this.loadUpags(idOrgao))
            )
            .subscribe(itens => {
                this.upagsItens = itens;
                const quantidade = this.upagsItens?.length ?? 0;
                this.opcoesCarregadas.emit({ quantidade, bloqueado: quantidade === 1 });
                if (quantidade === 1) {
                    setReadonlyValue(this, of(this.upagsItens[0].id));
                } else {
                    this.readonly = this.originalReadonlyValue;
                    setReadonlyValue(this, of(null));
                }
            });
    }
}
